import { c as _c } from "react/compiler-runtime";
import React from "react";
import Svg from "../Svg";
const Icon = props => {
  const $ = _c(11);
  const {
    color
  } = props;
  const t0 = color || "#1D2939";
  let t1;
  if ($[0] !== t0) {
    t1 = <path d="M3 7H21" stroke={t0} strokeWidth="1.5" strokeLinecap="round" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = color || "#1D2939";
  let t3;
  if ($[2] !== t2) {
    t3 = <path d="M3 12H21" stroke={t2} strokeWidth="1.5" strokeLinecap="round" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = color || "#1D2939";
  let t5;
  if ($[4] !== t4) {
    t5 = <path d="M3 17H21" stroke={t4} strokeWidth="1.5" strokeLinecap="round" />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t3 || $[9] !== t5) {
    t6 = <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>{t1}{t3}{t5}</Svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default Icon;